import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { SelectOptionI } from '../../../../../../shared/modules/configurable-form/components/form-select/models/select-option-i';
import { SelectOptionLoaderI } from '../../../../../../shared/modules/configurable-form/components/form-select/models/select-option-loader-i';
import { OrderBuilderState } from '../../../../../reducers';
import { SpecFieldNames } from '../../../../specification/constants/specification-field-names.enum';
import { getContractData } from '../../../selectors/contracts.selectors';
import { TranslateService } from '@ngx-translate/core';
import { rmsLoadAvailableContracts } from '@ordersnproducts/modules/shared/utils/rms-contracts-with-balance-loader.helper';

@Injectable()
export class ContractsOptionLoaderService implements SelectOptionLoaderI {
  constructor(
    private store: Store<OrderBuilderState>,
    private translate: TranslateService,
  ) {}

  /**
   * Provides an observable of the products
   * @return {Observable<SelectOptionI[]>}
   */
  loadOptions(formGroup: UntypedFormGroup): Observable<SelectOptionI[]> {
    return this.store.pipe(
      select(getContractData),
      filter((availableContracts) => !!availableContracts),
      map(({ availableContract, contractbalance, customer }) => {
        const productCode = formGroup.get(SpecFieldNames.PRODUCT_SELECTION).value;
        const contracts = availableContract[productCode];
        const contractCode = formGroup.get(SpecFieldNames.CONTRACT_SELECT).value;

        if (contracts && contracts.length === 1 && !contractCode) {
          formGroup.get(SpecFieldNames.CONTRACT_SELECT).setValue(contracts[0].documentCode.replace(/^0+/, ''));
        }
        if (contracts && contracts.length) {
          return rmsLoadAvailableContracts(contracts, contractbalance, this.translate, true, customer.countryCode);
        }
        return [];
      }),
    );
  }
}
